const DEFAULT_OPTIONS = {
  variant: "fade-up",
  delay: 0,
  threshold: 0.12,
  rootMargin: "0px 0px -6% 0px"
};

const prefersReducedMotion = () =>
  typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export const setupReveal = (el, options = {}) => {
  const { variant, delay, threshold, rootMargin } = { ...DEFAULT_OPTIONS, ...options };

  el.classList.add("reveal", `reveal-${variant}`);
  if (delay) {
    el.style.setProperty("--reveal-delay", `${delay}ms`);
  }

  if (prefersReducedMotion()) {
    el.classList.add("is-revealed");
    return null;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-revealed");
        observer.unobserve(entry.target);
      });
    },
    { threshold, rootMargin }
  );

  observer.observe(el);
  return observer;
};

const parseOptions = (binding) => {
  if (binding.value == null || binding.value === "") {
    return { ...DEFAULT_OPTIONS };
  }

  if (typeof binding.value === "string") {
    return { ...DEFAULT_OPTIONS, variant: binding.value };
  }

  return { ...DEFAULT_OPTIONS, ...binding.value };
};

export const scrollReveal = {
  mounted(el, binding) {
    el._revealObserver = setupReveal(el, parseOptions(binding));
  },
  unmounted(el) {
    el._revealObserver?.disconnect();
  }
};

export const scrollRevealStagger = {
  mounted(el, binding) {
    const step = binding.value?.step ?? 90;
    const variant = binding.value?.variant ?? "fade-up";
    const observers = [];

    Array.from(el.children).forEach((child, index) => {
      const observer = setupReveal(child, { variant, delay: index * step });
      if (observer) observers.push(observer);
    });

    el._revealObservers = observers;
  },
  unmounted(el) {
    el._revealObservers?.forEach((observer) => observer.disconnect());
  }
};
